import { render } from "./Headerhistory.vue?vue&type=template&id=f4759cbe&scoped=true"
import script from "./Headerhistory.vue?vue&type=script&lang=js"
export * from "./Headerhistory.vue?vue&type=script&lang=js"

import "./Headerhistory.vue?vue&type=style&index=0&id=f4759cbe&scoped=true&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4759cbe"]])

export default __exports__